/* Hero mini pricer (src/components/HeroMiniPricer.tsx). REVIEW-BG draft. */
import type { Catalogue } from "./index";

export const PRICER_BG: Catalogue = {
  "Instant indicative pricing": "Ориентировъчна цена веднага",
  From: "От",
  To: "До",
  Capacity: "Капацитет",
  "Est. from": "Ориентировъчно от",
  "/mo": "/мес.",
  "Price my connection": "Изчисли цена за връзка",
  "Price my connection — open configurator": "Изчисли цена за връзка, отваря конфигуратора",
  "Capacity: {capacity}": "Капацитет: {capacity}",
};
